import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { encodeLabInput, LAB_CHANGE } from '../utils/lab-change.util';

/**
 * Sends the user action of a lab save (LAB_CHANGE in the request context) as
 * X-Lab-* headers for the lab change log. A request without it is sent as it
 * is: the server then names the action after the route.
 *
 * Header names use hyphens: nginx drops headers with underscores by default.
 */
@Injectable()
export class LabChangeInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const change = request.context.get(LAB_CHANGE);
    if (!change) {
      return next.handle(request);
    }
    let headers = request.headers.set('X-Lab-Action', change.action);
    if (change.entryId) {
      headers = headers.set('X-Lab-Entry-Id', change.entryId);
    }
    const input = encodeLabInput(change.input);
    if (input) {
      headers = headers.set('X-Lab-Input', input);
    }
    return next.handle(request.clone({ headers }));
  }
}
